import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';
import apiService from '../services/apiService';
import cloneManager from '../services/cloneManager';
import RapportLevagePrintMobile from './RapportLevagePrintMobile';

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fffbeb, #fef3c7)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  content: {
    padding: '20px'
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#92400e',
    marginBottom: '16px'
  },
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '6px'
  },
  textarea: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    minHeight: '100px',
    resize: 'vertical'
  },
  select: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  },
  secondaryButton: {
    width: '100%',
    padding: '14px',
    marginTop: '10px',
    background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer'
  }
};

const AVIS_OPTIONS = [
  { value: 'favorable', label: 'Avis favorable' },
  { value: 'reserve', label: 'Avis favorable avec réserves' },
  { value: 'defavorable', label: 'Avis défavorable' }
];

function Etape6FinalisationLevageMobile({ mission, onBack, onSave }) {
  const [data, setData] = useState({
    avis: '',
    conclusions: '',
    recommandations: '',
    signature_date: new Date().toISOString().split('T')[0]
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showRapport, setShowRapport] = useState(false);
  const [rapportData, setRapportData] = useState(null);

  useEffect(() => {
    loadData();
  }, [mission.id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const savedData = await inspectionStorage.getStep(mission.id, 'etape_13_finalisation');
      if (savedData) {
        setData(prev => ({ ...prev, ...savedData }));
      }
    } catch (error) {
      console.error('❌ Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setData(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_13_finalisation', data);
      console.log('✅ Finalisation levage sauvegardée');
      if (onSave) onSave(data);
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  const handleShowRapport = async () => {
    try {
      const etape1 = await inspectionStorage.getStep(mission.id, 'etape_1_infos_generales_levage');
      const etape2 = await inspectionStorage.getStep(mission.id, 'etape_2_caracteristiques_techniques_levage');
      const observations = await inspectionStorage.getStep(mission.id, 'etape_11_observations');
      const finalisation = await inspectionStorage.getStep(mission.id, 'etape_13_finalisation');
      const parametresRes = await apiService.getParametres();
      const parametres = parametresRes.success ? (parametresRes.parametres[0] || {}) : {};
      const inspecteur = cloneManager.getInspecteur() || {};

      const rapport = {
        ...mission,
        etape_1_infos_generales_levage: etape1 || {},
        etape_2_caracteristiques_techniques_levage: etape2 || {},
        etape_11_observations: observations || { observations: [] },
        etape_13_finalisation: finalisation || {},
      };

      const client = {
        entreprise: mission.client_nom,
        adresse: mission.site_adresse,
        code_postal: mission.code_postal_etablissement,
        ville: mission.ville_etablissement,
        nom: mission.client_nom,
      };

      setRapportData({
        rapport,
        client,
        parametres,
        inspecteur,
      });
      setShowRapport(true);
    } catch (error) {
      console.error('❌ Erreur génération rapport levage:', error);
      alert('Erreur lors de la préparation du rapport.');
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#fffbeb' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e5e7eb', borderTopColor: '#f59e0b', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#92400e', fontWeight: '500' }}>Chargement...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Finalisation</h1>
        <button style={styles.backBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.content}>
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>✅ Avis du vérificateur</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Avis *</label>
            <select
              style={styles.select}
              value={data.avis}
              onChange={(e) => handleChange('avis', e.target.value)}
            >
              <option value="">Sélectionner...</option>
              {AVIS_OPTIONS.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Conclusions</label>
            <textarea
              style={styles.textarea}
              value={data.conclusions}
              onChange={(e) => handleChange('conclusions', e.target.value)}
              placeholder="Conclusions de la vérification..."
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Recommandations</label>
            <textarea
              style={styles.textarea}
              value={data.recommandations}
              onChange={(e) => handleChange('recommandations', e.target.value)}
              placeholder="Recommandations et suites à donner..."
            />
          </div>
        </div>
      </div>

      <div style={styles.saveSection}>
        <button style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6 } : {}) }} onClick={handleSave} disabled={saving}>
          {saving ? '⏳ Sauvegarde...' : '✅ Terminer l\'inspection'}
        </button>
        <button style={styles.secondaryButton} onClick={handleShowRapport}>
          🖨️ Prévisualiser / Imprimer PDF
        </button>
      </div>

      {showRapport && rapportData && (
        <RapportLevagePrintMobile
          mission={rapportData}
          onClose={() => setShowRapport(false)}
        />
      )}
    </div>
  );
}

export default Etape6FinalisationLevageMobile;